/**
 * Stable structural hash of a paginated response, focused on the fields whose
 * change should trigger a "stale data" indicator. Excludes user-mutable
 * derived fields and any UI-only concerns.
 *
 * Two responses produce the same hash iff their *server-authoritative* shape
 * is equal (same total + same items in same order with same numeric fields).
 */
export const hashItemsForStaleness = <T extends { id: number | string }>(
  items: T[] | undefined,
  extractFields: (item: T) => Record<string, unknown>
): string => {
  if (!items?.length) return '[]';
  return JSON.stringify(items.map(item => ({ id: item.id, ...extractFields(item) })));
};
